import Vue from "vue";

import ElementUI from "element-ui";
import 'element-ui/lib/theme-chalk/index.css'
import "./../element-variables.scss";
import "../theme/index.css";
import "./css/mobile.less";
import "./css/elementLocal.css";
// Element //
Vue.use(ElementUI);

import router from "./router";

import store from "./store";

import "whatwg-fetch";

import Vant from "vant";
import "vant/lib/index.css";
import "./css/vantLocal.css";

Vue.use(Vant);

import App from "./App.vue";

Vue.config.productionTip = false;
// isMobile: 是否手机用户, globalNotice：全局提醒框
const isMobile = /(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent);
const isAndroid = /Android/i.test(navigator.userAgent);

const globalNotice = {
  show: false,
  content: "",
};
new Vue({
  router,
  store,
  data: {isMobile, isAndroid, parentPath: "", parentTitle: "", globalNotice, goBackFunc: null},
  render: h => h(App),
}).$mount("#app");
